import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import UserContext from '../../contexts/UserContext';
import { useNavigate } from 'react-router-dom';
import authenticate from '../../utils/Authenticate';
import displayError from '../../utils/ErrorHandler';

const AddUser = () => {
  const { user, setUser } = useContext(UserContext);
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    zoneId: '',
    desc: '',
    address: '',
    cordinator: '',
    its: '',
    username: '',
    password: ''
  });
  const [notification, setNotification] = useState({ message: '', type: '' });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const submitData = (e) => {
    e.preventDefault();
    console.log(formData);
    const finalObject = {
      username: formData.username,
      password: formData.password,
      name: formData.cordinator,
      role: 'Zone Coordinator',
      its: formData.its,
      zone: {
        id: formData.zoneId,
        desc: formData.desc,
        address: formData.address
      }
    };

    axios.post(`${process.env.REACT_APP_API_URI}/api/users/register`, finalObject, { withCredentials: true })
      .then((response) => {
        console.log(response.data.message);
        setNotification({ message: response.data.message, type: 'success' });
        setFormData({
          zoneId: '',
          desc: '',
          address: '',
          cordinator: '',
          its: '',
          username: '',
          password: ''
        });
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
      });
      })
      .catch((err) => {
        const errorMessage = displayError(err,navigate,setUser);
        console.log(errorMessage);
          if(errorMessage){
            setNotification({ message: errorMessage, type: 'error' });
              window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
          }
      });
  };

  useEffect(() => {
    async function startup() {
      if (!user) {
        await authenticate(setUser, navigate);
      }
    }
    startup();
  }, [user, navigate, setUser]);

  const design = (
    <>
      <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-4 lg:px-8">
      {notification.message && (
          <div
            className={`m-2 mb-4 p-4 ${notification.type === 'success' ? 'bg-green-200 border-green-600 text-green-600' : 'bg-red-200 border-red-600 text-red-600'}`}
          >
            {notification.message}
          </div>
        )}
        <form className="space-y-6" onSubmit={submitData}>
          <div>
            <label htmlFor="zoneId" className="block text-sm font-medium leading-6 text-gray-900">
              Zone No
            </label>
            <div className="mt-2">
              <input
                id="zoneId"
                name="zoneId"
                type="number"
                placeholder='Zone No'
                autoComplete="zoneId"
                value={formData.zoneId}
                onChange={handleChange}
                required
                className="block w-full rounded-full border-0 py-3 px-5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>

          <div>
            <label htmlFor="desc" className="block text-sm font-medium leading-6 text-gray-900">
              Zone Name/Description
            </label>
            <div className="mt-2">
              <input
                id="desc"
                name="desc"
                type="text"
                placeholder='Zone Description'
                autoComplete="desc"
                value={formData.desc}
                onChange={handleChange}
                required
                className="block w-full rounded-full border-0 py-3 px-5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>

          <div>
            <label htmlFor="desc" className="block text-sm font-medium leading-6 text-gray-900">
              Zone Address
            </label>
            <div className="mt-2">
              <input
                id="address"
                name="address"
                type="text"
                placeholder='Zone address'
                autoComplete="address"
                value={formData.address}
                onChange={handleChange}
                required
                className="block w-full rounded-full border-0 py-3 px-5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>

          <div>
            <label htmlFor="cordinator" className="block text-sm font-medium leading-6 text-gray-900">
              Coordinator Name
            </label>
            <div className="mt-2">
              <input
                id="cordinator"
                name="cordinator"
                type="text"
                placeholder='Zone coordinator'
                autoComplete="cordinator"
                value={formData.cordinator}
                onChange={handleChange}
                required
                className="block w-full rounded-full border-0 py-3 px-5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>

          <div>
            <label htmlFor="cordinator" className="block text-sm font-medium leading-6 text-gray-900">
              Coordinator ITS
            </label>
            <div className="mt-2">
              <input
                id="its"
                name="its"
                type="text"
                placeholder='Zone coordinator ITS'
                autoComplete="its"
                value={formData.its}
                onChange={handleChange}
                required
                className="block w-full rounded-full border-0 py-3 px-5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
              />
            </div>
          </div>

          <label className="block text-sm font-medium leading-6 text-gray-900">
            Cordinator Credentials
          </label>
          <div className="flex min-h-full flex-1 flex-col justify-center px-1 py-1 lg:px-8">
            <div>
              <label htmlFor="username" className="block text-sm font-medium leading-6 text-gray-900">
                Username
              </label>
              <div className="mt-1">
                <input
                  id="username"
                  name="username"
                  type="username"
                  placeholder='Username'
                  autoComplete="username"
                  value={formData.username}
                  onChange={handleChange}
                  required
                  className="block w-full rounded-full border-0 py-3 px-5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>

            <div className='mt-2'>
              <div className="flex items-center justify-between">
                <label htmlFor="password" className="block text-sm font-medium leading-6 text-gray-700">
                  Password
                </label>
              </div>
              <div className="mt-2">
                <input
                  id="password"
                  name="password"
                  type="password"
                  placeholder='Password'
                  autoComplete="current-password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                  className="block w-full rounded-full border-0 py-3 px-5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                />
              </div>
            </div>
          </div>

          <div>
            <button
              type="submit"
              onClick={submitData}
              className="flex w-full justify-center rounded-full text-white bg-fmb px-3 py-3 text-sm font-semibold leading-6 shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
            >
              SUBMIT
            </button>
          </div>
        </form>
      </div>
    </>
  );
  return design;
};

export default AddUser;
